<template>
  <div class="productSort">
    <div class="head-bot-box">
      <div class="head-bot-tx"><img :src="info.picture" alt /></div>
      <div class="head-bot-right">
        <div class="stores-title">{{ info.merchant_name }}</div>
        <div style="font-weight: initial;font-size: 12px">
          距离：{{ info.distance }}
        </div>
        <div class="stores-time">{{ info.address }}</div>
        <div class="stores-xiaoxi">
          <a :href="'tel:' + info.phone" style="color: #ffffff"
            >电话：{{ info.phone }}</a
          >
          <span
            class="iconfont icon-dianhua_o"
            style="transform: rotate(200deg);display: inline-block;margin-left: 5px;"
          ></span>
        </div>
      </div>
      <form @submit.prevent="submitForm">
        <div class="header acea-row row-center-wrapper" ref="header">
          <div class="acea-row row-between-wrapper input">
            <span class="iconfont icon-sousuo"></span>
            <input type="text" placeholder="搜索商品信息" v-model="search" />
          </div>
        </div>
      </form>
    </div>
    <div class="middle">
      <span
        class="middle-left"
        :class="tabIndex == 0 ? 'active middle-left' : 'middle-left'"
        @click="tabTap(0)"
        >简介</span
      >
      <span
        class="middle-right"
        :class="tabIndex == 1 ? 'active middle-left' : 'middle-left'"
        @click="tabTap(1)"
        >列表</span
      >
    </div>
    <div
      v-show="!aside1"
      class="mendianjianjie"
      style="width: 100%;padding: 24px;"
    >
      <img :src="info.picture" alt="" style="width: 100%;" />
      <div class="stores-title" style="margin-top: 12px;">
        {{ info.merchant_name }}
      </div>
      <div style="font-weight: initial;font-size: 12px;margin-top: 12px;">
        距离：{{ info.distance }}
      </div>
      <div class="stores-time" style="margin-top: 12px;">
        {{ info.address }}
      </div>
    </div>
    <div class="aside" v-show="aside1">
      <div
        class="item acea-row row-center-wrapper"
        :class="index === navActive ? 'on' : ''"
        v-for="(item, index) in category"
        :key="index"
        @click="
          asideTap(index, item.id, item.cate_name, item.merchant_id, item.pid)
        "
      >
        <span>{{ item.cate_name }}</span>
      </div>
    </div>
    <div class="conter" @scroll.native="onScroll" v-show="aside1">
      <div class="listw">
        <div
          class="title acea-row row-center-wrapper"
          ref="title"
          style="display: none;"
          v-for="(item, index) in category"
        ></div>
        <div></div>
        <div class="list acea-row">
          <!-- <router-link v-for="(item, index2) in productList2" :key="index">
            <div>
              <div class="left">
                <img :src="item.image" alt="" />
              </div>
              <div class="right">
                <span>名字：{{ item.store_name }}</span>
                <span>钻石会员价：{{ item.store_name }}</span>
                <span>黄金会员价：{{ item.store_name }}</span>
                <span>普通价格：{{ item.store_name }}</span>
              </div>
            </div>
          </router-link> -->
          <router-link
            class="item acea-row row-column row-middle"
            v-for="(child, index) in productList2"
            :key="index"
            :to="{
              path: '/detail',
              query: {
                id: child.id,
                mid: child.merchant_id,
                type: 2,
                is_exchange: info.is_exchange
              }
            }"
          >
            <div class="item2">
              <div class="left">
                <div class="picture"><img :src="child.image" /></div>
                <!-- <div class="name line1">{{ child.store_name }}</div> -->
              </div>
              <div class="right" style="display:block">
                <div class="name">{{ child.store_name }}</div>
                <span
                  >价格：￥{{ child.price }}
                  <img src="../../../public/gouwu.png" alt=""
                /></span>
              </div>
            </div>
          </router-link>
        </div>
        <div
          style="text-align:center;height:0.5rem;line-height:0.5rem;font-size:0.3rem"
        >
          {{ listnone }}
        </div>
      </div>
    </div>
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import debounce from "lodash.debounce";
import { getCategory2, getGoodList } from "@api/store";
import { getHomeData, getShare } from "@api/public";
import { trim } from "../../utils";
import { isWeixin } from "@utils/index";
import { getMerchantDetail, getOffLineCategory } from "@api/mendian";
export default {
  name: "GoodsClass",
  components: {},
  props: {},
  data: function() {
    return {
      category: [],
      navActive: this.$route.query.index,
      search: "",
      lock: false,
      productList2: "",
      data: {},
      id: "",
      id2: "",
      id5: "",
      id6: "",
      page: 1,
      info: [],
      tag: 0,
      listnone: "",
      index: this.$route.query.index,
      location: "112.58138,37.858257",
      tabIndex: 1,
      aside1: true
    };
  },
  watch: {
    "$route.params.pid": function(n) {
      console.log(n);
      if (n) {
        this.activeCateId(n);
      }
    }
  },
  // created(index, id, name) {
  //   this.asideTap(index, id, name);
  // },
  mounted: function() {
    this.setOpenShare(); //获取定位
    this.merchant_id = this.$route.params.id;
    this.tag = this.$route.query.tag;
    this.getMerchant();
    document.addEventListener("scroll", this.onScroll, false);
    this.loadCategoryData();
  },
  methods: {
    tabTap(index) {
      this.tabIndex = index;
      if (this.tabIndex == 1) {
        this.aside1 = true;
      } else {
        this.aside1 = false;
      }
    },
    getMerchant: function() {
      var that = this;
      getMerchantDetail({
        id: that.merchant_id,
        location: that.location
      }).then(res => {
        that.info = res.data;
        console.log(that.info);
      });
    },
    activeCateId(n) {
      let index = this.$route.query.index;
      console.log(index);
      n = parseInt(n);
      if (!n) return;
      this.category.forEach((cate, i) => {
        if (cate.id === n) index = i;
      });

      if (index !== this.navActive) {
        this.asideTap(index, id, name, id2, id3);
      }
    },
    loadCategoryData() {
      getOffLineCategory(this.merchant_id, this.tag).then(res => {
        this.category = res.data;
        if (!res.data[0]) {
          return false;
        }
        let id = res.data[0].id;
        let name = res.data[0].cate_name;
        let id2 = res.data[0].merchant_id;
        let id3 = res.data[0].pid;
        this.id5 = res.data[0].id;
        this.id6 = res.data[0].merchant_id;
        this.page = 1;
        let data = {
          page: this.page,
          limit: 8,
          // keyword: name,
          sid: id, //二级分类id
          news: 0,
          priceOrder: "",
          merchant_id: id2,
          salesOrder: ""
        };
        getGoodList(data).then(res => {
          this.productList2 = res.data;
        });
        // this.$nextTick(() => {
        //   if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
        //   else this.onScroll();
        // });
      });
    },
    setOpenShare: function() {
      let that = this;
      getShare().then(res => {
        var data = res.data.data;
        var configAppMessage = {
          desc: data.synopsis,
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        var configTimeline = {
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        if (isWeixin() === true) {
          ready().then(() => {
            //获得定位并更新门店数据
            wx_getLocation().then(res => {
              that.location = res.longitude + "," + res.latitude;
              that.GLOBAL.location = that.location;
              getHomeData({
                location: that.location,
                diqu_id: that.diquId
              }).then(res => {
                that.$set(that, "merchant", res.data.info.merchant);
              });
            });
            openShareAppMessage(configAppMessage).then(() => {});
            openShareTimeline(configTimeline).then(() => {});
          });
        }
      });
    },
    submitForm: function() {
      var val = trim(this.search);
      // console.log(this.id6)
      // console.log(val);
      // return false;
      if (val) {
        this.$router.push({
          path: "/goods_list",
          query: {
            s: val,
            mid: this.id6
          }
        });
        setTimeout(() => (this.search = ""), 500);
      }
    },
    asideTap(index, id, name, id2, id3) {
      this.productList2 = [];
      console.log(index, id, name);
      const top =
        this.$refs.title[index].offsetTop -
        this.$refs.header.offsetHeight -
        window.scrollY;
      this.id = id;
      this.id2 = id2;
      this.lock = true;
      window.scrollBy({
        top,
        left: 0,
        behavior: "smooth"
      });
      this.navActive = index;
      var that = this;
      that.page = 1;
      let data = {
        page: that.page,
        limit: 8,
        // keyword: name,
        sid: id, //二级分类id
        news: 0,
        priceOrder: "",
        merchant_id: id2,
        salesOrder: ""
      };
      getGoodList(data).then(res => {
        that.listnone = "";
        that.productList2 = res.data;
      });
    },
    onScroll: debounce(function() {
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
        { scrollY } = window,
        titles = this.$refs.title;
      if (this.id == "") {
        this.id = this.id5;
        this.id2 = this.id6;
      }
      this.page++;
      let data = {
        page: this.page,
        limit: 8,
        // keyword: name,
        sid: this.id, //二级分类id
        news: 0,
        priceOrder: "",
        merchant_id: this.id2,
        salesOrder: ""
      };
      var that = this;
      that.listnone = "加载中...";
      getGoodList(data).then(res => {
        if (this.category.length == 0) {
          that.listnone = "";
          return false;
        }
        if (res.data.length == 0) {
          that.listnone = "到底了";
        } else {
          that.listnone = "";
        }
        that.productList2 = that.productList2.concat(res.data);
      });
      titles.reduce((initial, title, index) => {
        if (initial) return initial;
        const parent = title.parentNode || title.parentElement;
        console.log(headerHeight);
        // if (
        //   scrollY + headerHeight + 15 <
        //   title.offsetTop + parent.offsetHeight
        // ) {
        //   initial = true;
        //   this.navActive = index;
        // }
        // else if (innerHeight + scrollY + 15 > offsetHeight) {
        //   this.navActive = titles.length - 1;
        //   initial = true;
        // }
        return initial;
      }, false);
    }, 500)
  },
  beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
  }
};
</script>

<style scoped>
.mendianjianjie {
  position: fixed;
  top: 4.1rem;
  text-align: center;
}
.active {
  background-color: #f5f5f5;
}
.middle {
  width: 100%;
  height: 40px;
  position: fixed;
  top: 3.2rem;
  background-color: rgba(43, 43, 43, 0.1);
  font-size: 16px;
}
.middle-left {
  width: 50%;
  display: inline-block;
  text-align: center;
  line-height: 40px;
  color: #000000;
}
.middle-right {
  width: 50%;
  display: inline-block;
  text-align: center;
  line-height: 40px;
  color: #000000;
}
.productSort .aside {
  top: 4.1rem;
}

.productSort .header {
  top: 2.2rem;
}

.productSort .conter {
  margin-top: 3.8rem;
}

.head-bot-box {
  width: 100%;
  padding: 15px 0 0 10px;
  background: #0cc150;
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0px;
  z-index: 9;
}

.head-bot-box .head-bot-tx {
  width: 30%;
  height: 2.2rem;
}

.head-bot-box .head-bot-tx img {
  width: 100%;
  height: 100%;
  background-size: cover;
}

.head-bot-box .head-bot-right {
  width: 68%;
  height: 2.2rem;
}

.head-bot-box .head-bot-right div {
  color: white;
}

.head-bot-box .head-bot-right .stores-title {
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 3px;
  width: 205px;
  height: 25px;
  line-height: 33px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.head-bot-box .head-bot-right .stores-time {
  margin-bottom: 3px;
  height: 1.2em;
  width: 205px;
  height: 16px;
  line-height: 16px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.head-bot-box .head-bot-right .stores-xiaoxi {
  width: 100%;
  line-height: 30px;
  background: #42d178;
  padding: 0 0.5rem;
  position: absolute;
}

.productSort .conter .list .item {
  width: 100% !important;
  margin-top: 0.2rem !important;
  border-bottom: 1px solid rgba(40, 40, 40, 0.1);
  padding-bottom: 0.2rem !important;
}

.productSort .conter .list .item .name {
  font-size: 0.3rem !important;
  width: 2.4rem !important;
  text-align: left !important;
  height: auto !important;
}
.productSort .conter .list .item .picture {
  /* box-shadow: 0px 0px 4px 0px !important; */
  border-radius: 0% !important;
}
.productSort .conter .list .item .picture img {
  /* box-shadow: 0px 0px 4px 0px !important; */
  border-radius: 0% !important;
}
.productSort .conter .list .item .item2 .right span {
  color: #00c049 !important;
}
.productSort .conter .list .item .item2 {
  width: 100% !important;
  display: -webkit-flex;
  display: flex;
  align-items: center;
}

.productSort .conter .list .item .item2 .left {
  width: 1.2rem;
  margin-left: 10px;
}

.productSort .conter .list .item .item2 .right {
  flex: 1;
  margin-left: 10px;
  display: flex;
  height: 90%;
  flex-direction: column;
}

.productSort .conter .list .item .item2 .right span {
  display: block;
  flex: 1;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  width: 3.5rem;
}

.productSort .conter .list .item .item2 .right span img {
  width: 0.55rem;
  float: right;
  /* margin-top: -0.6rem; */
  border: 1px solid;
  border-radius: 100%;
  padding: 5px;
}
</style>
